var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useState, useEffect } from 'react';
import { getSymbolForCurrency } from '../../../../../app/common/money';
import { SHOP_CURRENCY } from '../../../../../app/main/shops/constants';
import { formattedRawValue, getRawValue } from './helpers';
import { Input } from '../../../../infra/dls/components/input';
import { useReduxSelector } from '../../../../infra/redux-bridge';
import styles from './styles.module.scss';
export var CurrencyInput = forwardRef(function (props, ref) {
    var value = props.value, onChange = props.onChange, _a = props.precision, precision = _a === void 0 ? 2 : _a, _b = props.separator, separator = _b === void 0 ? '.' : _b, _c = props.delimiter, delimiter = _c === void 0 ? ',' : _c, _d = props.allowEmpty, allowEmpty = _d === void 0 ? false : _d, _e = props.integer, integer = _e === void 0 ? false : _e, _f = props.useIsoCurrencyCode, useIsoCurrencyCode = _f === void 0 ? false : _f;
    var reduxCurrency = useReduxSelector('auth.currency');
    var currency = props.currency || reduxCurrency || SHOP_CURRENCY.usd;
    var currencySymbol = getSymbolForCurrency(currency);
    var prefix = props.prefix || (useIsoCurrencyCode ? currency.toUpperCase() : currencySymbol);
    var _g = useState(value), rawValue = _g[0], setRawValue = _g[1];
    useEffect(function () {
        if (value !== undefined || allowEmpty) {
            setRawValue(value);
        }
    }, [value, allowEmpty]);
    var onInputType = function (event) {
        var input = event.target.value;
        if (!/^[+-]?[,\d]*(\.\d*)?$/.test(input)) {
            return;
        }
        var newRawValue = getRawValue({ displayedValue: input, delimiter: delimiter, separator: separator, allowEmpty: allowEmpty });
        if (!allowEmpty && !newRawValue) {
            newRawValue = 0;
        }
        onChange(newRawValue);
        setRawValue(newRawValue);
    };
    return (_jsx(Input, __assign({}, props, { ref: ref, startIcon: _jsx("div", { className: styles['currency-symbol'], children: prefix }), onChange: onInputType, value: formattedRawValue({ val: rawValue, integer: integer, allowEmpty: allowEmpty, delimiter: delimiter, separator: separator, precision: precision }), type: "text", inputMode: "decimal" })));
});
CurrencyInput.displayName = 'CurrencyInput';
